export default __webpack_public_path__ + "2c2c533f75506a769898a6f38cda8dff.png";